"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDatumWithMetadata = void 0;
/**
 * Utility typeguard function for use in wrapping IncomingData<T, M> into WrappedData<T, M>
 * @param datum the data item to check
 */
var isDatumWithMetadata = function (
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
datum) {
    return datum.length === 2 && typeof datum[1] === "object";
};
exports.isDatumWithMetadata = isDatumWithMetadata;
